/* COE featured buy box. Standard and XL are separate products, so the Fit
   selector swaps which product's variants power the native product form. */
(function () {
  window.__cobbBuild = 9;
  /* Shopify serves the same asset at many sizes, so compare on the base filename
     rather than the full URL: .../bandit-2748271_900x.jpg?v=1 -> bandit-2748271 */
  function baseName(url) {
    var f = String(url || '').split('?')[0].split('/').pop();
    f = f.replace(/\.[a-z0-9]+$/i, '');
    return f.replace(/_(\d+)?x(\d+)?$/i, '');
  }
  function parseLines(str) {
    return String(str || '').split('\n').map(function (l) { return l.trim(); })
      .filter(Boolean).map(function (l) { return l.split('|').map(function (p) { return p.trim(); }); });
  }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (fmt && fmt.indexOf('{{') > -1) {
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]+>/g, '');
    }
    return '$' + v;
  }

  function Box(root) {
    var node = root.querySelector('[data-cobb-data]');
    if (!node) return;
    var D;
    try { D = JSON.parse(node.textContent); } catch (e) { return; }
    if (!D.std || !D.std.variants || !D.std.variants.length) return;

    var swatchMap = {}, lensMap = {};
    parseLines(D.swatches).forEach(function (r) { swatchMap[r[0]] = r[1] || '#ccc'; });
    parseLines(D.lensNotes).forEach(function (r) { lensMap[r[0]] = { note: r[1] || '', dot: r[2] || '#ccc' }; });

    var el = {
      main: root.querySelector('[data-cobb-main]'),
      video: root.querySelector('[data-cobb-video]'),
      dots: [].slice.call(root.querySelectorAll('[data-cobb-dot]')),
      stage: root.querySelector('.cobb-main'),
      tabsStd: root.querySelector('[data-cobb-tabs="std"]'),
      tabsXl: root.querySelector('[data-cobb-tabs="xl"]'),
      colors: root.querySelector('[data-cobb-colors]'),
      lenses: root.querySelector('[data-cobb-lenses]'),
      colorName: root.querySelector('[data-cobb-colorname]'),
      lensName: root.querySelector('[data-cobb-lensname]'),
      lensNote: root.querySelector('[data-cobb-lensnote]'),
      fitNote: root.querySelector('[data-cobb-fitnote]'),
      price: root.querySelector('[data-cobb-price]'),
      vtitle: root.querySelector('[data-cobb-vtitle]'),
      idInput: root.querySelector('[data-cobb-id]'),
      atc: root.querySelector('[data-cobb-atc]'),
      atcText: root.querySelector('[data-cobb-atctext]'),
      rx: root.querySelector('[data-cobb-rx]'),
      rxLine: root.querySelector('[data-cobb-rxline]'),
      form: root.querySelector('.cobb-form'),
      sticky: root.querySelector('[data-cobb-sticky]'),
      stickyPrice: root.querySelector('[data-cobb-sticky-price]'),
      stickyTitle: root.querySelector('[data-cobb-sticky-vtitle]'),
      stickyAdd: root.querySelector('[data-cobb-sticky-add]'),
      modes: [].slice.call(root.querySelectorAll('[data-cobb-mode]')),
      fits: [].slice.call(root.querySelectorAll('[data-cobb-fit]'))
    };

    var st = { fit: 'std', color: D.defaultColor || null, lens: D.defaultLens || null, mode: 'on', thumb: -1 };

    function prod() { return (st.fit === 'xl' && D.xl) ? D.xl : D.std; }
    function idx(p, name) {
      var i = (p.options || []).map(function (o) { return String(o).toLowerCase(); }).indexOf(name);
      return i;
    }
    function frameIdx(p) { var i = idx(p, 'frame'); return i < 0 ? 0 : i; }
    function lensIdx(p) { var i = idx(p, 'lens'); return i < 0 ? 1 : i; }
    function optOf(v, i) { return v.options ? v.options[i] : null; }

    function colorsFor(p) {
      var fi = frameIdx(p), out = [];
      p.variants.forEach(function (v) { var c = optOf(v, fi); if (c && out.indexOf(c) < 0) out.push(c); });
      return out;
    }
    function lensesFor(p, color) {
      var fi = frameIdx(p), li = lensIdx(p), out = [];
      p.variants.forEach(function (v) {
        if (optOf(v, fi) !== color) return;
        var l = optOf(v, li); if (l && out.indexOf(l) < 0) out.push(l);
      });
      return out;
    }
    function findVariant(p, color, lens) {
      var fi = frameIdx(p), li = lensIdx(p);
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (optOf(v, fi) === color && optOf(v, li) === lens) return v;
      }
      return null;
    }
    /* The theme stores a gallery video by putting its .mp4 URL in the image's alt
       text, with the image itself acting as the poster. Mirror that here. */
    function isVideo(entry) { return !!entry && /\.mp4(\?|$)/i.test(String(entry.alt || '')); }
    function asMedia(entry) {
      if (!entry) return null;
      if (isVideo(entry)) return { kind: 'video', src: String(entry.alt).trim(), poster: entry.src };
      return { kind: 'image', src: entry.src };
    }
    function pickMedia() {
      if (st.thumb >= 0 && D.images[st.thumb]) return asMedia(D.images[st.thumb]);
      var v = findVariant(prod(), st.color, st.lens);
      if (st.mode && D.images && D.images.length) {
        var key = st.mode === 'on' ? 'shields-on' : 'shields-off';
        for (var i = 0; i < D.images.length; i++) {
          if (String(D.images[i].alt || '').toLowerCase().indexOf(key) > -1) return asMedia(D.images[i]);
        }
      }
      if (v && v.featured_image && v.featured_image.src) return { kind: 'image', src: v.featured_image.src };
      return D.images && D.images[0] ? asMedia(D.images[0]) : null;
    }

    function render() {
      var p = prod();

      /* Only show colours the selected fit actually offers — matches the real
         product pages. Nothing is rendered disabled, so the fit note is moot. */
      var available = colorsFor(p);
      if (available.indexOf(st.color) < 0) st.color = available[0];
      var lenses = lensesFor(p, st.color);
      if (lenses.indexOf(st.lens) < 0) st.lens = lenses[0];

      el.colors.innerHTML = '';
      available.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cobb-sw';
        b.setAttribute('aria-label', c);
        b.setAttribute('aria-pressed', String(c === st.color));
        b.innerHTML = '<i style="background:' + (swatchMap[c] || '#ccc') + '"></i>';
        b.addEventListener('click', function () { st.color = c; st.thumb = -1; render(); });
        el.colors.appendChild(b);
      });
      if (el.fitNote) el.fitNote.hidden = true;

      el.lenses.innerHTML = '';
      lenses.forEach(function (l) {
        var v = findVariant(p, st.color, l);
        var meta = lensMap[l] || {};
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cobb-pill';
        b.setAttribute('aria-pressed', String(l === st.lens));
        b.innerHTML = '<i style="background:' + (meta.dot || '#ccc') + '"></i>' +
          '<span>' + l + '</span><s>' + (v ? money(v.price, D.moneyFormat) : '') + '</s>';
        b.addEventListener('click', function () { st.lens = l; st.thumb = -1; render(); });
        el.lenses.appendChild(b);
      });

      var variant = findVariant(p, st.color, st.lens);

      if (el.colorName) el.colorName.textContent = st.color || '';
      if (el.lensName) el.lensName.textContent = st.lens || '';
      if (el.lensNote) el.lensNote.textContent = (lensMap[st.lens] || {}).note || '';

      var priceText = variant ? money(variant.price, D.moneyFormat) : '';
      if (el.price) el.price.textContent = priceText;
      if (el.stickyPrice) el.stickyPrice.textContent = priceText;

      var vt = variant ? variant.title : '';
      if (el.vtitle) el.vtitle.textContent = vt;
      if (el.stickyTitle) el.stickyTitle.textContent = vt;

      if (variant && el.idInput) el.idInput.value = variant.id;

      var sellable = !!(variant && variant.available);
      if (el.atc) el.atc.disabled = !sellable;
      if (el.atcText) el.atcText.textContent = (sellable ? D.addText : D.soldOut) + (sellable && priceText ? ' · ' + priceText : '');
      if (el.stickyAdd) { el.stickyAdd.disabled = !sellable; el.stickyAdd.textContent = sellable ? D.addText : D.soldOut; }

      if (el.rx) {
        var href = st.fit === 'xl' && D.rx.xl ? D.rx.xl : D.rx.std;
        if (href) el.rx.setAttribute('href', href);
        if (el.rxLine) el.rxLine.textContent = st.fit === 'xl' ? (D.rxLine.xl || D.rxLine.std) : D.rxLine.std;
      }

      el.modes.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cobb-mode') === st.mode)); });
      el.fits.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cobb-fit') === st.fit)); });

      /* the tabs belong to a product, so swap them with the Fit selector */
      if (el.tabsXl) {
        el.tabsStd.hidden = st.fit === 'xl';
        el.tabsXl.hidden = st.fit !== 'xl';
      }


      var media = pickMedia();
      /* highlight the dot for whatever is actually showing, even when the image
         changed because of a colour swap rather than a dot click */
      if (media && el.dots.length) {
        var activeIdx = st.thumb;
        if (activeIdx < 0) {
          var want = baseName(media.kind === 'video' ? media.poster : media.src);
          for (var di = 0; di < D.images.length; di++) {
            var e = D.images[di];
            if (baseName(e.src) === want) { activeIdx = di; break; }
          }
          if (activeIdx < 0) activeIdx = 0;
        }
        el.dots.forEach(function (d, i) { d.setAttribute('aria-selected', String(i === activeIdx)); });
      }
      if (media && el.main) {
        if (media.kind === 'video' && el.video) {
          if (el.video.getAttribute('src') !== media.src) {
            el.video.setAttribute('src', media.src);
            el.video.setAttribute('preload', 'metadata');
          }
          if (media.poster) el.video.setAttribute('poster', media.poster);
          el.video.hidden = false;
          el.main.hidden = true;
          var p = el.video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          if (el.video) { el.video.hidden = true; el.video.pause(); }
          el.main.hidden = false;
          if (el.main.getAttribute('src') !== media.src) {
            el.main.setAttribute('src', media.src);
            el.main.removeAttribute('srcset');
          }
        }
      }
    }

    el.modes.forEach(function (b) {
      b.addEventListener('click', function () { st.mode = b.getAttribute('data-cobb-mode'); st.thumb = -1; render(); });
    });
    el.fits.forEach(function (b) {
      b.addEventListener('click', function () {
        var next = b.getAttribute('data-cobb-fit');
        if (next === 'xl' && !D.xl) return;
        st.fit = next; st.thumb = -1; render();
      });
    });
    el.dots.forEach(function (b, i) {
      b.addEventListener('click', function () { st.thumb = i; render(); });
    });

    /* swipe the main image, the way the slick gallery behaves on product pages */
    if (el.stage && D.images.length > 1) {
      var x0 = null, y0 = null;
      el.stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      el.stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var cur = st.thumb;
        if (cur < 0) {
          var sel = el.dots.findIndex ? el.dots.findIndex(function (d) { return d.getAttribute('aria-selected') === 'true'; }) : 0;
          cur = sel < 0 ? 0 : sel;
        }
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next < 0) next = D.images.length - 1;
        if (next > D.images.length - 1) next = 0;
        st.thumb = next; render();
      }, { passive: true });
    }
    if (el.stickyAdd && el.form) {
      el.stickyAdd.addEventListener('click', function () {
        if (typeof el.form.requestSubmit === 'function') el.form.requestSubmit(el.atc);
        else el.atc.click();
      });
    }

    /* sticky bar appears once the real button has scrolled off the top, mobile only */
    if (el.sticky && el.atc) {
      var lastPast = null;
      var syncSticky = function () {
        var past = el.atc.getBoundingClientRect().bottom < 0;
        if (past === lastPast) return;
        lastPast = past;
        el.sticky.classList.toggle('is-on', past);
        el.sticky.setAttribute('aria-hidden', String(!past));
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky, { passive: true });
      syncSticky();
    }

    render();
  }

  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-cobb]')).forEach(Box);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
